import { useEffect } from "react";
import { useSelector } from "react-redux";
import i18n from "../i18n";
import { RootState } from "../redux/store";

const useLanguageChange = () => {
  const language = useSelector((state: RootState) => state.Language);

  useEffect(() => {
    if (language && language.code) {
      // Persist so i18n.ts reads it on next page load
      localStorage.setItem("app_language", language.code);
      i18n.changeLanguage(language.code);
    }
  }, [language]);
};

export default useLanguageChange;
